import React from 'react'
import ChangeAllestimento from "../components/ChangeAllestimento";
import NavigationArrow from "../components/NavigationArrow";

export default function Scene10Mesh({setScene, setRender}) {
    return (
        <>
            <NavigationArrow setScene={setScene} sceneToSet={8} setRender={setRender} position={[20, -35, 80]} rotation={'rotateZ(0deg) rotateY(-10deg) rotateX(-50deg'}/>
            <ChangeAllestimento setScene={setScene} sceneToSet={9} setRender={setRender} position={[20, -5, 20]} rotation={'rotateZ(0deg) rotateY(0deg) rotateX(0deg'} />
        </>
    )
}
